const capitalize = {
  methods: {
    capitalize(string) {
      if (!string) return '';
      const temp = string.toString();
      const capitalizedString = temp.charAt(0).toUpperCase() + temp.slice(1).toLowerCase();
      return capitalizedString;
    },
  },
};

export default capitalize;



// WEBPACK FOOTER //
// ./src/mixins/capitalize.js